import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import * as firebase from 'firebase'
import router from './router/router'
import store from './store'
import AlertCmp from './components/shared/Alert.vue'

Vue.config.productionTip = false

Vue.component('app-alert', AlertCmp)

new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    firebase.initializeApp({
      apiKey: "AIzaSyD1tdAR9z5xCZn-Aayfx7dKqzOPnzo_K9A",
      authDomain: "projet-pense-bete.firebaseapp.com",
      databaseURL: "https://projet-pense-bete.firebaseio.com",
      projectId: "projet-pense-bete",
      storageBucket: "projet-pense-bete.appspot.com"
    })
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.$store.dispatch('autoSignIn', user)
      }
    })
    this.$store.dispatch('loadListes')
  }
}).$mount('#app')
